import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { InvestorUpdates } from './components/InvestorUpdates'
import { PageTitle } from '../../../_metronic/layout/core'
import { SendEmailUpdateBreadCurmbs } from './core/_constants'

import { useIntl } from 'react-intl'
import PitchDeck from './components/PitchDeck'
import Emails from './components/Emails'
import Templates from './components/Templates'
import CreateUpdates from './components/CreateUpdates'
import SendEmail from './components/SendEmail'
import { PdfPreview } from './components/PdfPreview'
import { useInvestorDatabase } from '../investor-database/core/InvestorContext'
import CreateTemplate from './components/CreateTemplate'

export const InvestorUpdatesRoutes = () => {
  const { investorUpdate } = useInvestorDatabase()
  const { formatMessage } = useIntl()
  const { storeFileName } = useInvestorDatabase()
  const {
    sendEmailBreadCrumbs,
    createUpdatesBreadCrumbs,
    editUpdatesBreadCrumbs,
    investorPitchDeckBreadCrumbs,
    investorPitchDeckPDFBreadCrumbs,
    investorUpdateBreadCrumbs,
  } = SendEmailUpdateBreadCurmbs()
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='update'
          element={
            <>
              <PageTitle
                breadcrumbs={investorUpdateBreadCrumbs}
                description={formatMessage({ id: 'Investor Updates' })}
              >
                {formatMessage({ id: 'Investor Updates' })}
              </PageTitle>
              <InvestorUpdates />
            </>
          }
        />

        <Route
          path='pitch-deck'
          element={
            <>
              <PageTitle
                breadcrumbs={investorPitchDeckBreadCrumbs}
                description={formatMessage({ id: 'Pitch Deck' })}
              >
                {formatMessage({ id: 'Pitch Deck' })}
              </PageTitle>
              <PitchDeck />
            </>
          }
        />

        <Route
          path='pdf/:pitchDeckId'
          element={
            <>
              <PageTitle breadcrumbs={investorPitchDeckPDFBreadCrumbs} description={storeFileName}>
                {formatMessage({ id: 'Pitch Deck' })}
              </PageTitle>
              <PdfPreview />
            </>
          }
        />

        <Route
          path='send-emails'
          element={
            <>
              <PageTitle
                breadcrumbs={investorPitchDeckBreadCrumbs}
                description={formatMessage({ id: 'Send Emails' })}
              >
                {formatMessage({ id: 'Investor Updates' })}
              </PageTitle>
              <Emails />
            </>
          }
        />
        <Route
          path='templates'
          element={
            <>
              <PageTitle
                breadcrumbs={investorPitchDeckBreadCrumbs}
                description={formatMessage({ id: 'Templates' })}
              >
                {formatMessage({ id: 'Investor Updates' })}
              </PageTitle>
              <Templates />
            </>
          }
        />
        <Route
          path='compose'
          element={
            <>
              <PageTitle
                breadcrumbs={sendEmailBreadCrumbs}
                description={formatMessage({ id: 'Send Emails' })}
              >
                {formatMessage({ id: 'Investor Updates' })}
              </PageTitle>
              <SendEmail />
            </>
          }
        />
        <Route
          path='create-update/:updateId'
          element={
            <>
              <PageTitle breadcrumbs={editUpdatesBreadCrumbs} description={investorUpdate?.title}>
                {formatMessage({ id: 'Save Updates' })}
              </PageTitle>
              <CreateUpdates />
            </>
          }
        />
        <Route
          path='create-update'
          element={
            <>
              <PageTitle breadcrumbs={createUpdatesBreadCrumbs}>
                {formatMessage({ id: 'Create Updates' })}
              </PageTitle>
              <CreateUpdates />
            </>
          }
        />
        <Route
          path='create-template'
          element={
            <>
              <PageTitle
                breadcrumbs={investorPitchDeckBreadCrumbs}
                description={formatMessage({ id: 'Templates' })}
              >
                {formatMessage({ id: 'Create Template' })}
              </PageTitle>
              <CreateTemplate />
            </>
          }
        />
        <Route
          path='create-template/:templateId'
          element={
            <>
              <PageTitle
                breadcrumbs={investorPitchDeckBreadCrumbs}
                description={formatMessage({ id: 'Templates' })}
              >
                {formatMessage({ id: 'Create Template' })}
              </PageTitle>
              <CreateTemplate />
            </>
          }
        />

        <Route index element={<Navigate to='/updates/update' />} />
      </Route>
    </Routes>
  )
}
